import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=0a99bda5&scoped=true&"
import script from "./RegionList.vue?vue&type=script&lang=js&"
export * from "./RegionList.vue?vue&type=script&lang=js&"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=0a99bda5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a99bda5",
  null
  
)

export default component.exports